import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DIASSEMANA, DIASSEMANAEXTENSO } from '@appNeo/core/global';

@Component({
  selector: 'app-campo-week-day-selector',
  templateUrl: './campo-week-day-selector.component.html',
  styleUrls: ['./campo-week-day-selector.component.scss']
})
export class CampoWeekDaySelectorComponent {
  @Input() controlCampo: FormControl;

  days = [
    { label: DIASSEMANA[1], full: DIASSEMANAEXTENSO[1], value: 1 },
    { label: DIASSEMANA[2], full: DIASSEMANAEXTENSO[2], value: 2 },
    { label: DIASSEMANA[3], full: DIASSEMANAEXTENSO[3], value: 3 },
    { label: DIASSEMANA[4], full: DIASSEMANAEXTENSO[4], value: 4 },
    { label: DIASSEMANA[5], full: DIASSEMANAEXTENSO[5], value: 5 },
    { label: DIASSEMANA[6], full: DIASSEMANAEXTENSO[6], value: 6 },
    { label: DIASSEMANA[7], full: DIASSEMANAEXTENSO[7], value: 7 }
  ];

  toggleDay(value: number): void {
    const selected = this.controlCampo?.value || [];
    const index = selected.indexOf(value);
    if (index >= 0) {
      selected.splice(index, 1);
    } else {
      selected.push(value);
    }
    this.controlCampo.setValue([...selected]);
    this.controlCampo.markAsDirty();
    this.controlCampo.markAsTouched();
  }

  isSelected(value: number): boolean {
    return this.controlCampo?.value?.includes(value);
  }
}
